import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { getIncidentById, put_Incident } from '../../../services/Tickets';
import useAuth from '../../../components/hooks/useAuth';
import useDelete from '../../../components/hooks/useDelete';
import { appName, ticketBaseURL } from '../../../configs/api';
import { getTicketStatusesByAttribute } from '../../../services/TicketStatus';
import { delete_fileUpload, getFileUploads, post_fileUpload, put_fileUpload } from '../../../services/FileUpload';
import { upload_CommonFileSupportTicket } from '../../../services/commonFile';
import { post_TicketComment, getThreadedComments } from '../../../services/TicketComments';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import { format } from 'date-fns';
import PleaseWaitPopup from '../../PleaseWaitPopup';
import { useTheme } from '../../../components/hooks/useTheme';
import { Button } from '@mui/material';
import colorConfigs from '../../../configs/colorConfigs';
import { CustomImagePopup } from '../../../components/common/CustomImagePopup';
import Cookies from 'js-cookie';
import moment from 'moment';
import useGeneral from '../../../components/hooks/useGeneral';

const EditSupportTicket = () => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { dateFormat }: any = useGeneral();
    const { themeStyles } = useTheme();
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const { id }: any = useParams();
    const [fileIndex, setFileIndex] = useState<number>(0);
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const [supportTicketData, setSupportTicketData] = useState<any>({
        accountId: 0,
        incidentName: "",
        status: "2",
        requester: "",
        description: "",
        categoryId: 0,
        subcategoryId: 0,
        assignedToUserId: 0,
        assignedToGroupAssignmentId: 0,
        priority: "",
        dueDate: "",
        emailCC: "",
        expectedRevenue: 0,
        groupId: "0",
        appGroupId: "0",
        appName: appName,
        createdAt: "",
        createdBy: "",
        updatedAt: "",
        updatedBy: ""
    });
    const [priorityData, setPriorityData] = useState<any[]>([]);
    const [isChanges, setIsChanges] = useState<boolean>(true);
    const [comments, setComments] = useState<any[]>([]);
    const [newComment, setNewComment] = useState<string>('');
    const [replyingTo, setReplyingTo] = useState<number | null>(null);
    const [replyPostingId, setReplyPostingId] = useState<number | null>(null);
    const [replyText, setReplyText] = useState<string>("");
    const [isLoadingComments, setIsLoadingComments] = useState(false);
    const [isPostingComment, setIsPostingComment] = useState(false);
    const [disabeld, setDisabled] = useState<boolean>(true);
    const [isDataUploading, setIsDataUploading] = useState<boolean>(false);
    const [isLoadingAttachments, setIsLoadingAttachments] = useState(false);
    const [attachmentsValue, setAttachmentsValue] = useState<any[]>([]);
    const [key, setKey] = useState<number>(0);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
    const [imagePopup, setImagePopup] = useState<boolean>(false);
    const fileRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        getTicketStatusesByAttribute('Priority')
            .then((res) => {
                setPriorityData(res?.data.reverse().map((item: any) => ({
                    value: item?.id,
                    label: item?.status
                })));
            })
    }, [])

    useEffect(() => {
        getIncidentById(id)
            .then(res => {
                setSupportTicketData({
                    ...res,
                    status: res.status !== "" && res.status !== "string" ? res.status : "0",
                    priority: res.priority !== "string" && res.priority !== "" ? res.priority : "0",
                    dueDate: res.dueDate?.split("T")[0]
                });
            })
            .catch((error) => {
                console.log(error)
            })
    }, [id]);

    useEffect(() => {
        if (!id || !isChanges) return;

        setIsLoadingComments(true);

        getThreadedComments("Incidents", id)
            .then((res) => {
                setComments(res.reverse());
                setIsChanges(false);
            })
            .catch((error) => console.log(error))
            .finally(() => setIsLoadingComments(false));
    }, [id, isChanges]);

    useEffect(() => {
        if (id && !isDataUploading) {
            setIsLoadingAttachments(true);

            getFileUploads("Incidents", id)
                .then((res) => {
                    setAttachmentsValue(res);
                })
                .catch((error) => console.log(error))
                .finally(() => setIsLoadingAttachments(false));
        }
    }, [id, isDataUploading]);

    const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!isDataUploading) {
            const selectedFiles = e.target.files as FileList;

            if (selectedFiles.length !== 0) {
                saveImageFile(selectedFiles[0]);
                if (fileRef.current) {
                    fileRef.current.value = '';
                    setKey((prevKey) => prevKey + 1);
                }
            }
        }
    };

    const updateFile = (e: React.ChangeEvent<HTMLInputElement>, imageid: number) => {

        setPleaseWaitPopup(true);
        const selectedFiles = e.target.files as FileList;
        if (selectedFiles.length !== 0) {
            const formData = new FormData();
            formData.append("ImageFile", selectedFiles[0]);
            setIsDataUploading(true);
            upload_CommonFileSupportTicket(formData)
                .then(res => {
                    put_fileUpload({
                        id: imageid,
                        attributeName: "Incidents",
                        attributeId: id,
                        fileName: res,
                        tabName: "Incidents",
                        userId: auth?.id,
                        createdDate: new Date()
                    })
                        .then(() => {
                            setIsDataUploading(false);
                            setPleaseWaitPopup(false);

                        })
                        .catch(error => console.error(error))
                })
                .catch(error => console.error(error))
        } else {
            setPleaseWaitPopup(false);
        }
    }

    const saveImageFile = (imageFile: File) => {
        setIsDataUploading(true);
        const formData = new FormData();
        formData.append("ImageFile", imageFile);

        upload_CommonFileSupportTicket(formData)
            .then(res => {
                post_fileUpload({
                    attributeName: "Incidents",
                    attributeId: id,
                    fileName: res,
                    tabName: "Incidents",
                    userId: auth?.id,
                    createdDate: new Date()
                })
                    .then(() => {
                        setIsDataUploading(false);
                    })
                    .catch(error => console.error(error))
            })
            .catch(error => console.error(error))
    }

    const viewImage = (index: number) => {
        setImagePopup(true);
        setFileIndex(index)
    }

    const deleteImage = (id: number) => {
        setDeleteData({
            id: id,
            title: `Delete`,
            summary: `Are you sure you want to delete this Attachment?`,
            isDelete: (callback: any) => {
                delete_fileUpload(id.toString())
                    .then(() => {
                        setAttachmentsValue((prev) => {
                            const updated = prev?.filter((item: any) => item?.id !== id);
                            return updated;
                        });
                    })
                    .catch((error) => {
                        console.error("Delete API Error:", error);
                    })
                    .finally(() => {
                        callback && callback();
                    });
            },
        });

        setDeletePopup(true);
    };

    const reloadComments = () => {
        setIsLoadingComments(true);

        getThreadedComments("Incidents", id)
            .then((res) => setComments(res.reverse()))
            .catch((err) => console.error(err))
            .finally(() => setIsLoadingComments(false));
    };

    const handleAddComment = async () => {
        if (!newComment.trim()) return;

        try {
            setIsPostingComment(true);

            await post_TicketComment({
                attributeName: "Incidents",
                attributeId: id,
                notes: newComment,
                userId: auth?.id,
                createdBy: auth?.givenname,
                createdDate: new Date().toISOString(),
                groupId: "",
                parentCommentId: ""
            });

            setNewComment("");
            reloadComments();
        } catch (err) {
            console.error(err);
        } finally {
            setIsPostingComment(false);
        }
    };

    const handleReply = async (parentId: number) => {
        if (!replyText.trim()) return;

        try {
            setReplyPostingId(parentId);

            await post_TicketComment({
                attributeName: "Incidents",
                attributeId: id,
                notes: replyText,
                userId: auth?.id,
                createdBy: auth?.givenname,
                createdDate: new Date().toISOString(),
                groupId: "",
                parentCommentId: parentId,
            });

            setReplyText("");
            setReplyingTo(null);
            setIsChanges(true);
        } catch (err) {
            console.error(err);
        } finally {
            setReplyPostingId(null);
        }
    };

    const renderComments = (list: any[], level = 0) => {
        return list.map((c: any) => (
            <div
                key={c.id}
                className={`${level > 0 ? "ml-10 border-l-2 border-gray-200 pl-4" : ""} mt-3`}
            >
                <div className="bg-gray-50 border rounded-xl p-3">
                    <div className="flex items-center justify-between">
                        <p className={`text-sm font-semibold ${themeStyles.main.tailwindLabelTextColor}`}>
                            {c.createdBy || "Unknown User"}
                        </p>

                        <p className="text-xs text-gray-400">
                            {c?.createdDate ? moment(new Date(c.createdDate)).format(dateFormat + " hh:mm a") : ""}
                        </p>
                    </div>

                    <p className={`text-sm mt-1 whitespace-pre-wrap ${themeStyles.main.tailwindLabelTextColor}`}>
                        {c.notes}
                    </p>

                    {!disabeld && !isStatusNew && (
                        <div className="flex gap-4 mt-2 text-xs text-gray-500">
                            <button
                                type="button"
                                onClick={() => setReplyingTo(c.id)}
                                disabled={replyPostingId === c.id}
                                className={`text-[#167AC3] font-medium text-sm
                                 hover:text-[#136aa7]
                                 hover:underline underline-offset-4
                                 transition-all duration-200
                                 ${replyPostingId === c.id ? "opacity-50 cursor-not-allowed" : ""}`}
                            >
                                Reply
                            </button>
                        </div>
                    )}

                    {replyingTo === c.id && (
                        <div className="mt-3 flex gap-2 items-start">
                            <textarea
                                className="w-full border rounded p-2 text-sm text-black"
                                placeholder={`Reply...`}
                                value={replyText}
                                onChange={(e) => setReplyText(e.target.value)}
                            />

                            <button
                                type="button"
                                disabled={replyPostingId === c.id}
                                onClick={() => handleReply(c.id)}
                                className={`px-3 py-2 rounded text-sm text-white self-start
                                 shadow-sm hover:shadow-md active:shadow-sm
                                 transition-all duration-200
                                  ${replyPostingId === c.id ? "bg-gray-400 cursor-not-allowed" : "bg-[#167AC3]"}`}
                            >
                                {replyPostingId === c.id ? "Posting..." : "SEND"}
                            </button>
                        </div>
                    )}
                </div>

                {c.replies && c.replies.length > 0 && (
                    <div className="mt-3 space-y-3">
                        {renderComments(c.replies, level + 1)}
                    </div>
                )}
            </div>
        ));
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPleaseWaitPopup(true);

        put_Incident({
            ...supportTicketData,
            priority: supportTicketData.priority,
            createdAt: new Date().toISOString(),
            createdBy: auth?.givenname,
            updatedAt: new Date().toISOString(),
            updatedBy: auth?.givenname,
            tenantId: tenantId
        }, auth?.id)
            .then(() => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch(error => {
                setPleaseWaitPopup(false);
                console.error(error);
            });
    }

    const isStatusNew = supportTicketData.status === 'Closed';

    return (
        <>
            <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
                <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
                    <div className="w-full mt-2">
                        <div className={`w-full pb-4`}>

                            <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                <div className="flex items-center gap-1.5">
                                    <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Edit Support Ticket</h2>
                                </div>
                                {
                                    disabeld && (
                                        <button
                                            className={`px-[8px] py-[6px] bg-transparent shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                                            onClick={() => setDisabled(false)}
                                        >
                                            <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>
                                                edit
                                            </span>
                                            <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>Edit</span>
                                        </button>
                                    )
                                }
                            </div>

                            <div className="mt-2 p-2 w-full">
                                <form
                                    onSubmit={(e) => handleSubmit(e)}
                                >
                                    <div className="w-[60%] px-2">
                                        <div className="w-full">

                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Subject</label>
                                            <input
                                                disabled={disabeld}
                                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                value={supportTicketData.incidentName}
                                                onChange={(e) => setSupportTicketData({ ...supportTicketData, incidentName: e.target.value })}
                                                required
                                            />
                                        </div>

                                        <div className="w-full mt-4">

                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Description</label>
                                            <textarea
                                                disabled={disabeld}
                                                className={`w-full px-[8px] py-[8px]  border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                rows={6}
                                                value={supportTicketData.description}
                                                onChange={(e) => setSupportTicketData({ ...supportTicketData, description: e.target.value })}
                                            />
                                        </div>

                                        <div className="mt-4 w-full">

                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Priority</label>
                                            <select
                                                disabled={disabeld}
                                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                value={supportTicketData.priority}
                                                onChange={(e) => {
                                                    setSupportTicketData({ ...supportTicketData, priority: e.target.value });
                                                }}
                                            >

                                                {
                                                    priorityData.map((item: any, index: number) => {
                                                        return <option key={index} className={`${themeStyles.main.tailwindSectionBg}`} value={item.value}>{item.label}</option>
                                                    })
                                                }

                                            </select>
                                        </div>

                                        <div className='mt-4 w-full'>
                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Attachment</label><br />

                                            {
                                                !disabeld && (
                                                    <>
                                                        <Button
                                                            key={key}
                                                            variant="contained"
                                                            sx={{
                                                                backgroundColor: "#FFFFFF",
                                                                color: "#167AC3",
                                                                border: "1px solid #167AC3",
                                                                marginTop: "10px"
                                                            }}
                                                            onClick={() => fileRef.current?.click()}

                                                        >
                                                            {isDataUploading ? (
                                                                <>
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="18px"
                                                                        className="mr-2 fill-tertiary inline animate-spin"
                                                                        viewBox="0 0 26.349 26.35"
                                                                    >
                                                                        <circle cx="13.792" cy="3.082" r="3.082" />
                                                                        <circle cx="13.792" cy="24.501" r="1.849" />
                                                                    </svg>
                                                                    Processing...
                                                                </>
                                                            ) : (
                                                                <div className='flex gap-1.5 items-center'>
                                                                    <CloudUploadIcon style={{ color: "#167AC3" }} />
                                                                    <span className={`text-sm font-medium`}>Add Attachment</span>
                                                                </div>
                                                            )}
                                                        </Button>

                                                        <input
                                                            ref={fileRef}
                                                            type="file"
                                                            accept="image/png, image/jpeg"
                                                            name="image-choose"
                                                            style={{ display: 'none' }}
                                                            onChangeCapture={onFileChangeCapture}
                                                        />
                                                    </>
                                                )
                                            }
                                        </div>

                                        <div className='w-full flex gap-1.5 mt-4'>
                                            {isLoadingAttachments && (
                                                <div className="flex items-center justify-center py-6 text-gray-600 text-sm">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="18"
                                                        height="18"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                        className="mr-2 animate-spin"
                                                    >
                                                        <circle cx="12" cy="12" r="10" strokeOpacity=".25" />
                                                        <path d="M4 12a8 8 0 0 1 8-8" />
                                                    </svg>
                                                    Loading attachments...
                                                </div>
                                            )}

                                            {!isLoadingAttachments && attachmentsValue?.length === 0 && (
                                                <p className="text-sm text-gray-500">No attachments.</p>
                                            )}
                                            {!isLoadingAttachments && attachmentsValue?.length !== 0 && (
                                                <div className="flex flex-wrap gap-4 col-span-2">
                                                    {attachmentsValue?.map((_, index) => (
                                                        <div
                                                            key={index}
                                                            className="relative w-40 h-40 group"
                                                            onMouseEnter={(e) => {
                                                                const deleteIcon = e.currentTarget.querySelector('.delete-icon') as HTMLElement;
                                                                if (deleteIcon) deleteIcon.style.visibility = 'visible';
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                const deleteIcon = e.currentTarget.querySelector('.delete-icon') as HTMLElement;
                                                                if (deleteIcon) deleteIcon.style.visibility = 'hidden';
                                                            }}
                                                        >

                                                            <div
                                                                className="delete-icon absolute top-1 right-1 bg-slate-200 rounded cursor-pointer"
                                                                style={{ color: "#167AC3", visibility: 'hidden' }}
                                                                onClick={() => deleteImage(index)}
                                                            >
                                                                <DeleteIcon />
                                                            </div>

                                                            <div
                                                                className="w-full h-full rounded-md cursor-pointer"
                                                                onClick={() => viewImage(index)}
                                                            >
                                                                <img
                                                                    className="w-full h-24 rounded-md"
                                                                    src={`${ticketBaseURL}commonFile/Get?name=${_?.fileName}`}
                                                                    alt={_?.fileName}
                                                                />
                                                                <div className="bg-gray-100 w-full mb-4 text-xs flex flex-col justify-center items-center px-3 py-1.5">
                                                                    <span className="font-semibold" style={{ color: "#167AC3" }}>
                                                                        {_?.fileName}
                                                                    </span>
                                                                    <span style={{ color: "#167AC3" }}>
                                                                        {format(new Date(_?.createdDate), 'dd MMM yyyy, hh:mm a')}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}

                                        </div>

                                        <div className="w-full mt-4">
                                            <div className="flex items-center justify-between mb-3">
                                                <p className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Comments</p>
                                            </div>

                                            {!disabeld && (
                                                <div className="flex gap-2">
                                                    <textarea
                                                        className="w-full border rounded p-2 text-sm"
                                                        placeholder="Write a comment..."
                                                        value={newComment}
                                                        onChange={(e) => setNewComment(e.target.value)}
                                                    />

                                                    <button
                                                        type="button"
                                                        onClick={handleAddComment}
                                                        disabled={isPostingComment}
                                                        className={`px-3 py-2 rounded text-sm text-white self-start
                                                         shadow-sm hover:shadow-md active:shadow-sm
                                                         transition-all duration-200
                                                         ${isPostingComment ? "bg-gray-400 cursor-not-allowed" : "bg-[#167AC3]"}`}
                                                    >
                                                        {isPostingComment ? (
                                                            <>
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="16"
                                                                    height="16"
                                                                    viewBox="0 0 24 24"
                                                                    fill="none"
                                                                    stroke="currentColor"
                                                                    strokeWidth="2"
                                                                    className="inline mr-2 animate-spin"
                                                                >
                                                                    <circle cx="12" cy="12" r="10" strokeOpacity=".25" />
                                                                    <path d="M4 12a8 8 0 0 1 8-8" />
                                                                </svg>
                                                                Posting...
                                                            </>
                                                        ) : (
                                                            "POST"
                                                        )}
                                                    </button>
                                                </div>
                                            )}

                                            <div
                                                className={`mt-4 overflow-y-auto space-y-4 pr-2 border rounded-lg p-3 ${themeStyles.main.tailwindMainBg}
    ${(isLoadingComments || comments.length > 0) ? "h-[55vh]" : "min-h-[80px]"}
  `}
                                            >
                                                {isLoadingComments ? (
                                                    <div className="flex items-center justify-center py-6 text-gray-600 text-sm">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="18"
                                                            height="18"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                            className="mr-2 animate-spin"
                                                        >
                                                            <circle cx="12" cy="12" r="10" strokeOpacity=".25" />
                                                            <path d="M4 12a8 8 0 0 1 8-8" />
                                                        </svg>
                                                        Loading comments...
                                                    </div>
                                                ) : comments.length === 0 ? (
                                                    <p className="text-sm text-gray-500">No comments yet.</p>
                                                ) : (
                                                    renderComments(comments)
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex gap-4 mt-8 ml-2">
                                        {
                                            !disabeld && (
                                                <Button variant="contained"
                                                    sx={{
                                                        backgroundColor: colorConfigs.btn.main.bg
                                                    }}
                                                    type="submit">
                                                    Save
                                                </Button>
                                            )
                                        }

                                        <Button variant="contained"
                                            sx={{
                                                backgroundColor: colorConfigs.btn.cancel.bg,
                                                border: colorConfigs.btn.cancel.border,
                                                color: colorConfigs.btn.cancel.color
                                            }}
                                            onClick={() => navigate(-1)}>
                                            Cancel
                                        </Button>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <CustomImagePopup
                showPopup={imagePopup}
                handlePopup={() => setImagePopup(false)}
                filePath={attachmentsValue}
                fileIndex={fileIndex}
                setFileIndex={setFileIndex}
                imageBaseUrlPath="commonFile"
                isSupportTicket={true}
                updateFile={updateFile}
            />
            <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
        </>
    );
}

export default EditSupportTicket;